import { STATUS } from "@/constants/statuses";
import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { CustomerAddressEntity } from "../entities/CustomerAddressEntity";
import { GiftRegistryTypeEntity } from "../entities/GiftRegistryTypeEntity";
import { GiftRegistryWithItemsEntity } from "../entities/GiftRegistryWithItemsEntity";

export type GiftRegistryState = {
    registries: GiftRegistryWithItemsEntity[];
    sharedRegistry: GiftRegistryWithItemsEntity | null;
    registryTypes: GiftRegistryTypeEntity[];
    customerAddresses: CustomerAddressEntity[];
    sharingStatus: STATUS;
    changeRegistryStatus: STATUS;
    customerAddressesStatus: STATUS;
    loadMoreStatus: STATUS;
    itemsLoadingInRegistriesStatuses: Record<number, number[]>;
};

function createInitialState(): GiftRegistryState {
    return {
        registries: [],
        sharedRegistry: null,
        registryTypes: [],
        customerAddresses: [],
        sharingStatus: STATUS.VIRGIN,
        changeRegistryStatus: STATUS.VIRGIN,
        customerAddressesStatus: STATUS.VIRGIN,
        loadMoreStatus: STATUS.VIRGIN,
        itemsLoadingInRegistriesStatuses: {},
    };
}

@singleton()
@StoreConfig({ name: "GiftRegistryStore" })
class GiftRegistryStore extends BaseStore<GiftRegistryState> {
    constructor() {
        super(createInitialState());
    }

    setSharingStatus(sharingStatus: STATUS): void {
        this.update((state) => ({ ...state, sharingStatus }));
    }

    setChangeRegistryStatus(changeRegistryStatus: STATUS): void {
        this.update((state) => ({ ...state, changeRegistryStatus }));
    }

    setCustomerAddressesStatus(customerAddressesStatus: STATUS): void {
        this.update((state) => ({ ...state, customerAddressesStatus }));
    }

    setLoadMoreStatus(loadMoreStatus: STATUS): void {
        this.update((state) => ({ ...state, loadMoreStatus }));
    }

    setItemLoadingInRegistry(productId: number, registryId: number) {
        this.update((state) => ({
            ...state,
            itemsLoadingInRegistriesStatuses: {
                ...state.itemsLoadingInRegistriesStatuses,
                [productId]: [
                    ...(state.itemsLoadingInRegistriesStatuses[productId] ||
                        []),
                    registryId,
                ],
            },
        }));
    }

    unSetItemLoadingInRegistry(productId: number, registryId: number) {
        this.update((state) => ({
            ...state,
            itemsLoadingInRegistriesStatuses: {
                ...state.itemsLoadingInRegistriesStatuses,
                [productId]: state.itemsLoadingInRegistriesStatuses[
                    productId
                ].filter((_registryId) => _registryId !== registryId),
            },
        }));
    }
}

export default GiftRegistryStore;
